import { Component, EventEmitter, inject, Input, input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { LookupDataService } from '../../services/lookup-data.service';
import { AssessmentService } from '../../services/assessment.service';
import { LookupItem } from '../../models/lookup-item';
import { Observable } from 'rxjs';
import { NavigationService } from '../../services/navigation.service';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { IFormTypes } from '../../data/form-types';
import { ILookup } from '../../data/Ilookup';
import { DecisionDetails } from '../../data/decision-details';
import { IFileUploadResult } from '../../models/i-file-upload-result';
import { IFormComponent } from '../../models/i-form-component';
import { IVisaType } from '../../data/visa-type';

@Component({
  selector: 'app-decision',
  templateUrl: './decision.component.html',
  styleUrl: './decision.component.scss'
})
export class DecisionComponent implements OnInit, IFormComponent {
   @Input()model!: InitialAssessmentForm;
   @Input()formTypes!: IFormTypes;
   @Input()visaTypes!: IVisaType[];
   @Input()appealDecisionBy!: LookupItem[];
   @Input()notifiedBy!: LookupItem[]
   @Output() formReady = new EventEmitter<FormGroup>();

  isAppealCancel: boolean = false;

  
  formBuilder = inject(NonNullableFormBuilder);

  decisionForm = this.formBuilder.group({
    visaType: [null as IVisaType | null],
    whoMadeDecision: [null as LookupItem | null],
    decisionDate: [''],
    notifiedBy: [null as LookupItem | null],
    notifiedDate: [''],
    whyAppeal: ['']
  });

  constructor(private assessmentService: AssessmentService, private navigationService: NavigationService) {


  }


  ngOnInit(): void {

    this.initializeForm();
    this.isAppealCancel = this.navigationService.isSelectedRouteFor(this.formTypes.appealCancel);

  }

  initializeForm(): void {

    this.model = this.model || new InitialAssessmentForm();
    this.model.decision = this.model.decision || new DecisionDetails();


    this.decisionForm.patchValue({
      visaType: this.model.decision.visaType,
      whoMadeDecision: this.model.decision.whoMadeDecision,
      decisionDate: this.model.decision.decisionDate,
      notifiedBy: this.model.decision.notifiedBy,
      notifiedDate: this.model.decision.notifiedDate,
      whyAppeal: this.model.decision.whyAppeal
    });


   this.decisionForm.valueChanges.subscribe(formValues => {
    this.model.decision!.visaType = formValues.visaType ?? null;
    this.model.decision!.whoMadeDecision = formValues.whoMadeDecision ?? null;
    this.model.decision!.decisionDate = formValues.decisionDate || '';
    this.model.decision!.notifiedBy = formValues.notifiedBy ?? null;
    this.model.decision!.notifiedDate = formValues.notifiedDate || '';
    this.model.decision!.whyAppeal = formValues.whyAppeal || '';
    });


    this.formReady.emit(this.decisionForm);


  }

onFileUploaded(fileResult: IFileUploadResult | null): void {
  console.log('File uploaded:', fileResult);
  
  if (fileResult) {
       this.model.decision!.decisionFile = [{ name: fileResult.file.name, size: fileResult.file.size, type: fileResult.file.type, key: fileResult.key }];
       this.model.decision!.fileLocation = fileResult.fileId;
  } else {
        this.model.decision!.decisionFile = [];
        this.model.decision!.fileLocation = '';
  }
}

  isFormValid(): boolean {
    return this.decisionForm.valid;
  }

  markFormAsTouched(): void {
    this.decisionForm.markAllAsTouched();
  }

}
